import { ReactNode } from "react";
import { InfoHint } from "./InfoHint.tsx";
import { classNames } from "../../UI/Utils/classNames.ts";

export function StatisticsCard({
  title,
  description,
  info,
  actions,
  spansWholeRow = false,
  children,
}: {
  title: string;
  description?: string;
  info?: string;
  actions?: ReactNode;
  spansWholeRow?: boolean;
  children: ReactNode;
}) {
  return (
    <section
      className={classNames(
        "p-4 w-full min-w-0 bg-white rounded-lg shadow-md shadow-slate-200 flex flex-col gap-4",
        spansWholeRow ? "xl:col-span-2" : undefined,
      )}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex flex-col gap-0.5 min-w-0">
          <div className="flex items-center gap-1.5">
            <h3 className="text-base font-semibold text-gray-800">{title}</h3>
            {info && <InfoHint text={info} />}
          </div>
          {description && (
            <p className="text-xs text-gray-500">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex flex-wrap items-center gap-2">{actions}</div>
        )}
      </div>
      {children}
    </section>
  );
}

export function LoadingBlock({ className }: { className: string }) {
  return (
    <div className={`animate-pulse rounded-md bg-gray-100 ${className}`} />
  );
}

export function EmptyStatistics({ children }: { children: ReactNode }) {
  return <p className="py-8 text-center text-sm text-gray-400">{children}</p>;
}

export function Stat({
  label,
  value,
  children,
}: {
  label: string;
  value: string;
  children?: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-0.5 min-w-0">
      <span className="text-xs text-gray-500">{label}</span>
      <span className="text-xl font-bold text-gray-800">{value}</span>
      {children}
    </div>
  );
}
